import React from 'react';
//Components
import Map from "../components/Map";
import HeaderSignup from "../components/HeaderSignup";
import Apply from "../components/Apply";

const SignUp = () => {
    return (
        <>
            <div className='md:px-4 mx-auto sm:max-w-xl md:max-w-full  md:px-24 lg:px-8 md:bg-grisclaro_rancagua'>
                <HeaderSignup/>
                <Apply/>
                <div className='mt-48'>
                    <Map/>
                </div>
            </div>
        </>
    );
};

export default SignUp;